import { AutoColumn } from "../../components/Column";
import styled from "styled-components";
import { RowBetween } from "../../components/Row";
import { ThemedText } from "../../theme";
import { Trans } from "@lingui/macro";
import NoDataContent from "../../components/NoDataContent";
import { Coffee, Plus } from "react-feather";
//import { useMiniPool } from '../../hooks/useContract';
import useNodes from "../../hooks/useNodes";
import useAppGroup from "../../hooks/useAppGroup";
import useToken from '../../hooks/useToken';
import { CPNODES_ADDRESS,TOKEN_ADDRESS, GROUPAPP_ADDRESS } from "../../constants/address";
// import { MINI_POOL_ADDRESS } from '../../constants/address';
import { useEffect, useMemo, useState } from "react";
import NodeItem from "./components/NodeItem";
// import UserNodeInfo from "./components/UserNodeInfo";

import UserNodeItem from "./components/UserNodeItem";
import NodePledgeModal from "./components/NodePledgeModal";
import NodeUpdateModal from "./components/NodeUpdateModal";
import { useWallet } from "use-wallet";
import Loader from "../../components/Loader";
import Big from "big.js";

const Wrapper = styled(AutoColumn)`
  max-width: 820px;
  width: 100%;
`;

const ThemedTextWrapper = styled(ThemedText.Black)`
  box-sizing: border-box;
  margin: 0;
  min-width: 0;
  font-weight: 400;
  font-size: 20px;
`;

const PoolsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 16px;
  column-gap: 16px;
  padding-bottom: 10px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    grid-template-columns: 1fr;
  `};
`;

function Nodes() {
  const { account, chainId } = useWallet();
  // const blockNumber = getBlockNumber();
  const nodeOpt = useNodes(CPNODES_ADDRESS[chainId]);
  const appgroupOpt = useAppGroup(GROUPAPP_ADDRESS[chainId]);
  
  const [updateopen, setUpdateopen] = useState(false);
  const [pledgeopen, setPledgeopen] = useState(false);
  const [curUserNodeItem, setCurUserNodeItem] = useState(null);

  const [loading, setLoading] = useState(true);
  const [nodeApps, setNodeApps] = useState([]);
  const [nodeAppsObj, setNodeAppsObj] = useState({});
  const [userNodeList, setUserNodeList] = useState([]);
  const [minPledge, setMinPledge] = useState('0');
  
  const [token] = useToken(TOKEN_ADDRESS[chainId]);


  useEffect(() => {
    const fetch = async () => {
      //const ntoken=await nodeOpt.getToken();
      //console.log("ntoken",ntoken);

      const tmpnodeApps = await appgroupOpt.getAppsList(setLoading);
      // console.log("getPkgInfoList", nodeApps);
      setNodeApps(tmpnodeApps);
      
      const tmpapplist={};
      for (let index = 0; index < tmpnodeApps.length; index++) {
        tmpapplist[tmpnodeApps[index].appid]=tmpnodeApps[index]
      }
      setNodeAppsObj(tmpapplist);
  

      const  tmpminledge= await nodeOpt.getMinPledge();
      setMinPledge(tmpminledge);
      

        const tmpuserpkglist = await nodeOpt.getAdminNodeList(
          account,0,
          setLoading
        );
        setUserNodeList(tmpuserpkglist);
      //}
    };
    if (nodeOpt.nodeContract && appgroupOpt.getAppsList) {
      fetch();
    }
    // nodeOpt, TODO 为什么不能nodeOpt 导致死循环
  }, [account, nodeOpt.nodeContract,appgroupOpt.getAppsList]);

  return (
    <Wrapper>
      <AutoColumn gap={"24px"} style={{ width: "100%" }}>
        {userNodeList && !userNodeList.length && (
          <NoDataContent
          
            text={
              <>
                <div>
                  <Trans>
                    You have not a node yet. Please create a node.
                  </Trans>
                </div>
                <div>{loading ? <Loader /> : null}</div>
              </>
            }
          />
        )}

                <RowBetween>
          <ThemedTextWrapper>
            <Trans>My Compute Nodes</Trans>
          </ThemedTextWrapper>
        </RowBetween>
        <PoolsWrapper>
        {userNodeList &&
          userNodeList.map((userPkgitem) => (
            <UserNodeItem
              setUpdateopen={setUpdateopen}
              setPledgeopen={setPledgeopen}
              setCurUserNodeItem={setCurUserNodeItem}
              userPkgInfo={userPkgitem}
              nodeAppsObj={nodeAppsObj}
              nodeOpt={nodeOpt}
            />
          ))}
           </PoolsWrapper>
        <RowBetween>
          <ThemedTextWrapper>
            <Trans>All Compute Nodes </Trans>
          </ThemedTextWrapper>
        </RowBetween>
        {account && nodeApps && nodeApps.length ? (
          <PoolsWrapper>
            {nodeApps.map((pkgitem) => (
              <NodeItem key={pkgitem.appid} minPledge={minPledge} pkgitem={pkgitem} nodeOpt={nodeOpt} />
            ))}
          </PoolsWrapper>
        ) : (
          <NoDataContent
            icon={<Coffee size={48} />}
            text={
              <>
                <div>
                  <Trans>All Node Info will appear here.</Trans>
                </div>
                <div>{loading ? <Loader /> : null}</div>
              </>
            }
          />
        )}
      </AutoColumn>


      {token && curUserNodeItem && <NodePledgeModal
        isOpen={pledgeopen}
        setIsOpen={setPledgeopen}
        token={token}
        nodeOpt={nodeOpt}
        pkgitem={curUserNodeItem}
      />}

{token && curUserNodeItem && <NodeUpdateModal
        isOpen={updateopen}
        setIsOpen={setUpdateopen}
        token={token}
        nodeOpt={nodeOpt}
        pkgitem={curUserNodeItem}
      />
      }
    </Wrapper>
  );
}

export default Nodes;
